<template>
    <LayoutPayment>
        <div class="container-fluid banner-pm pb-5 camera-services-page mt-lg-5">
            <section-header :tabType="1" :tabPosition="1" :nameCheck="home"></section-header>
            <div v-if="sectionSelectedPackage">
                <section-payment-service
                    v-model="sectionSelectedPackage.Qty" :title="sectionSelectedPackage.CmsContent.display_name"
                    :price="sectionSelectedPackage.RealPromotionMonth" :unit="sectionSelectedPackage.CmsContent.unit" color="#FF8840"
                    :infoPackage="sectionSelectedPackage.CmsContent.description" @input="sectionSelectedPackage.Qty = $event" :max="maxPackage"
                    :loadingPrice="loadingPrice"></section-payment-service>
            </div>
            <section-payment-info-box :title="label.registerTitle" icon="icon-info-orange" class="w-736">
                <!-- PHONE, DATE OF BIRTHDAY -->
                <form-group>
                    <form-input id="phone" ref="PhoneSMS" fieldName="phoneNumber" :label="label.phoneNumber"
                        typeInput="number" :required="true" :requireMessage="label.phoneNumberRequired" :isPhone="true"
                        :isPhoneMessage="label.phoneNumberInvalid" v-model="userInfo.PhoneSMS"
                        inputPlaceholder="0123456789" maxlength="10"></form-input>
                </form-group>
                <form-group>
                    <div class="mb-2">
                        <span class="fptplay__font-weight--700-color--gray--uppercase">chọn hình thức kích hoạt dịch
                            vụ</span>
                    </div>
                    <div class="form-group form-row fptplay__min-with--webkit-fill-available">
                        <div class="col-md-6 mb-3 mb-md-0">
                            <div class="iradio checked d-flex align-items-center">
                                <!-- input radio -->
                                <input class="default-radio" type="radio" id="1" :value="2" v-model="chosenActive" />
                                <!-- label -->
                                <label class="mx-3 d-flex align-items-center fptplay__lable-text-transform--none" for="1">
                                    <span class="text-bold text-16 clo-black">Kích hoạt tự động</span>
                                </label>
                                <i class="ico-grey fptplay__tooltip-custom">
                                    <svg aria-hidden="true" width="16" height="16" title="FPT TELECOM">
                                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-info-orange">
                                        </use>
                                    </svg>
                                    <span class="tooltip__text">
                                        <div class="fptplay__text-margin-10">
                                            {{ autoActive }}
                                        </div>
                                    </span>
                                </i>
                            </div>
                        </div>
                        <div class="col-md-6" v-if="sectionSelectedPackage.SysName !== 'FPTPlay-SA-XMAS'">
                            <div class="iradio checked d-flex align-items-center">
                                <!-- input radio -->
                                <input class="default-radio" type="radio" id="0" :value="1" v-model="chosenActive" />
                                <!-- label -->
                                <label class="mx-3 d-flex align-items-center fptplay__lable-text-transform--none" for="0">
                                    <span class="text-bold text-16 clo-black">Khách hàng tự kích hoạt</span>
                                </label>
                                <i class="ico-grey fptplay__tooltip-custom">
                                    <svg aria-hidden="true" width="16" height="16" data-toggle="tooltip"
                                        title="FPT TELECOM">
                                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-info-orange">
                                        </use>
                                    </svg>

                                    <span class="tooltip__text">
                                        <div class="fptplay__text-margin-10">{{ manualActive }}</div>
                                    </span>
                                </i>
                            </div>
                        </div>
                    </div>
                </form-group>
            </section-payment-info-box>

            <UtmBannerRegister
                    serviceCode="fpt-play-sa"
            />

            <section-payment-info-box class="w-736" v-if="sectionPrepayMonthData.length > 0">
                <!-- titte -->
                <h4 class="text-16 text-bold my-4 d-flex align-items-center fptplay__mt-0">
                    <icon class="d-block mr-3 ico-orange" iconName="icon-time-orange" :iconSvg="false"></icon>
                    <span class="clo-black23">{{ label.prepayMonthTitle }}</span>
                </h4>
                <form-group class="mb-0">
                    <ul class="col radio-list">
                        <form-radio-item v-for="(prepayItem, prepayIndex) in sectionPrepayMonthData"
                            :key="`prepay-${prepayIndex}`" :valueRadio="prepayItem.key" radioName="prepay"
                            v-model="prepayMonth">
                            <div class="d-flex flex-column">
                                <span class="clo-black23 d-block text-16 text-bold">{{ prepayItem.title }}</span>
                                <div style="margin-top: 10px">
                                    <section-price :isFptPlay="true" :price="prepayItem.RealPromotionMonth"
                                        :oldPrice="prepayItem.RealMonth"></section-price>
                                </div>
                            </div>
                        </form-radio-item>
                    </ul>
                </form-group>
            </section-payment-info-box>

            <section-payment-info-box class="w-736">
                <!-- titte -->
                <h4 class="text-16 text-bold my-4 d-flex align-items-center fptplay__mt-0">
                    <div>
                        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M16 17C16 17.552 15.551 18 15 18H3C2.449 18 2 17.552 2 17V6C2 5.448 2.449 5 3 5V6C3 7.103 3.897 8 5 8H13C14.103 8 15 7.103 15 6V5C15.551 5 16 5.448 16 6V17ZM5 2L13 2.003V3V6H5V3V2ZM15 3V2C15 0.897 14.103 0 13 0H5C3.897 0 3 0.897 3 2V3C1.346 3 0 4.346 0 6V17C0 18.654 1.346 20 3 20H15C16.654 20 18 18.654 18 17V6C18 4.346 16.654 3 15 3Z"
                                fill="#FF8840" />
                        </svg>
                    </div>

                    <span class="clo-black23 fptplay__span-padding-left--20px">
                        Quý khách có muốn nhận hoá đơn không?
                    </span>
                </h4>
                <div class="form-group form-row">
                    <div class="col-md-6 mb-3 mb-md-0">
                        <div class="iradio checked d-flex align-items-center">
                            <!-- input radio -->
                            <input class="default-radio" type="radio" id="2" :value="1" v-model="receiptInfoCheck" />
                            <!-- label -->
                            <label class="mx-3 d-flex align-items-center fptplay__lable-text-transform--none" for="2">
                                <span class="text-bold text-16 clo-black">Có </span>
                            </label>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="iradio checked d-flex align-items-center">
                            <!-- input radio -->
                            <input class="default-radio" type="radio" id="3" :value="0" v-model="receiptInfoCheck" />
                            <!-- label -->
                            <label class="mx-3 d-flex align-items-center fptplay__lable-text-transform--none" for="3">
                                <span class="text-bold text-16 clo-black">Không</span>
                            </label>
                        </div>
                    </div>
                </div>
            </section-payment-info-box>

            <section-payment-info-box class="w-736" v-show="receiptInfoCheck == 1">
                <form-group>
                    <form-input id="name" ref="FullName" fieldName="fullName" :label="label.fullName" :isName="true"
                        :required="receiptInfoCheck ? true : false" :requireMessage="label.fullNameRequired"
                        :showClearButton="true" v-model="userInfo.FullName" inputPlaceholder="Nguyễn Văn A"></form-input>
                </form-group>
                <label class="mb-2">
                    <span class="fptplay__font-weight--700-color--gray--uppercase"> Địa chỉ </span>
                    <span class="required clo-red abc text-20">*</span>
                </label>
                <section-address id="address" ref="address" :address="address" :required="receiptInfoCheck ? true : false"
                    :isFptPlaySA="true"></section-address>
            </section-payment-info-box>
            <div class="container w-736 p-0 mt-4">
                <div class="row">
                    <div class="col-12 d-flex flex-column">
                        <button type="button" :class="['btn btn-custom btn-booking orange', { active: !processing }]"
                            @click="checkForm">
                            {{ label.nextStep }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <ConfirmModal ref="notification-modal" :title="notificationModalInfo.title" :iconId="notificationModalInfo.iconId"
            :message="notificationModalInfo.message" :okBtnText="notificationModalInfo.okBtnText" hideCancelBtn
            :checkBtn="isCheckBtn" @click-ok="processing = false" @click-khtn="pushKHTN" />
        <ConfirmModal ref="error-modal" :title="errorModalInfo.title" :iconId="errorModalInfo.iconId"
            :message="errorModalInfo.message" :okBtnText="errorModalInfo.okBtnText" @click-cancel="backToHome"
            @click-ok="backToHome" hideCancelBtn />
    </LayoutPayment>
</template>
<script>
import { PAYMENT_FLOW } from '../../../configs/constants';
import SectionPrice from '../../../mycore/components/SectionPrice.vue';
import * as api from '../module/api-sp';
import { getPotentialCustomer } from '../module/api';
import { mixins } from '../../mixin';
import { mixinRegister } from '../../../mycore/utils/mixin-register';
import { scrollToError } from '../../../mycore/module/utils';
import { ROUTER_NAME } from '../module/routes';
import ConfirmModal from '../component/confirmModal.vue';
import UtmBannerRegister from '../../../mycore/components/UtmBannerRegister.vue';

export default {
    mixins: [mixins, mixinRegister],
    components: { SectionPrice, ConfirmModal, UtmBannerRegister },
    data() {
        return {
            maxPackage: 0,
            loadingPrice: true,
            isCheckBtn: true,
            notificationModalInfo: {
                title: '',
                iconId: '',
                message: '',
                okBtnText: '',
            },
            orderCode: 0,
            orderId: 0,
            autoActive: 'Hệ thống đã tự động kích hoạt gói dịch vụ, khách hàng truy cập gói FPT Play để sử dụng. ',
            manualActive:
                'Mã code sẽ được gửi qua SMS của quý khách. Vui lòng truy cập ứng dụng FPT Play để kích hoạt & sử dụng.',
            notPackageAvailable:
                'Hiện tại, sản phẩm/ dịch vụ mà quý khách đã chọn chưa hỗ trợ chính sách mở bán tại khu vực của quý khách. Mời quý khách kiểm tra lại khu vực đã chọn hoặc chọn đăng ký sản phẩm/dịch vụ khác. Liên hệ 1900 6600 để được tư vấn giải đáp. Xin cảm ơn.',
            chosenActive: 2,
            receiptInfoCheck: 0,
            receiptChecking: [
                {
                    id: 0,
                    text: 'Không',
                },
                {
                    id: 1,
                    text: 'Có',
                },
            ],
            home: ROUTER_NAME.home,
            urlPaymentFlow: PAYMENT_FLOW.FPTPLAY_SA,
            label: {
                prepayMonthTitle: 'Chọn thời gian sử dụng',
                registerTitle: 'Thông tin đăng ký',
                nextStep: 'Tiếp tục',
                fullName: 'HỌ VÀ TÊN',
                taxCode: 'MÃ SỐ THUẾ',
                fullNameRequired: 'Vui lòng nhập họ tên',
                phoneNumber: 'SỐ ĐIỆN THOẠI SỬ DỤNG DỊCH VỤ',
                phoneNumberRequired: 'Vui lòng nhập số điện thoại',
                phoneNumberInvalid: 'Số điện thoại của bạn không đúng định dạng',
            },
            processing: false,
            sectionSelectedPackage: {
                CmsContent:{
                    description:'',
                    display_name:'',
                    short_name:'',
                    unit:''
                },
            },
            sectionPrepayMonthData: [],

            options: {
                minValue: 0,
                maxValue: 99,
            },
            userInfo: {
                FullName: 'Khách hàng lẻ',
                PhoneSMS: '',
            },
            prepayMonth: 12,
            address: {
                locationid: 8,
                locationname: 'Hồ Chí Minh',
                districtid: 1,
                districtname: 'Q1',
                wardid: 1,
                wardname: 'Phường Bến Nghé',
                streetid: 0,
                streetname: '',
                housenumber: '',
                housetype: 1,
            },
            location: {
                locationid: 8,
                locationname: 'Hồ Chí Minh',
                districtid: 1,
                districtname: 'Q1',
                wardid: 1,
                wardname: 'Phường Bến Nghé',
                streetid: 0,
                streetname: '',
                housenumber: '',
                housetype: 1,
            },
            loadCachedPackages: true,
            orderCode: '',
            orderId: 0,
            namebtn: '',
            nametitle: '',
            errorModalInfo: {
                title: '',
                iconId: '',
                message: '',
                okBtnText: '',
            },
        };
    },
    methods: {
        showErrorModal(message, title = 'Thông báo', iconId = '#icon-voucher', okBtnText = 'Đồng ý') {
            this.errorModalInfo = {
                title,
                iconId,
                message,
                okBtnText,
            };
            this.$refs['error-modal'].showModal();
            this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                this.backToHome();
            });
        },
        backToHome() {
            window.scrollTo(0, 0);
            this.$router
                .push({
                    name: ROUTER_NAME.home,
                })
                .catch(() => { });
        },
        callbackPotentialCustomer(isSuccess, data, error) {
            if (isSuccess) {
                this.$router
                    .push({
                        name: ROUTER_NAME.finishPotentialCustomers,
                    })
                    .catch(() => { });
            }
        },
        getDefaultLocation() {
            const location = this.getFromCache('dataLocation') || this.getFromSessions('dataLocation');
            if (location) {
                this.location = location;
            }
        },
        handleSaveData() {
            const location = this.receiptInfoCheck ? this.address : this.location;
            this.addToCache('dataLocation', location);
            this.addToSessions('dataLocation', location);
            this.addToSessions('receiptInfoCheck', this.receiptInfoCheck);
            this.addToSessions('chosenActive', this.chosenActive);
            this.$store.dispatch('fptplay/updateUserInfo', this.userInfo);
            const dataRegister = this.getFromSessions('dataRegister');
            if(dataRegister){
                this.addToSessions('dataRegister', {
                    ...dataRegister,
                    fullname: this.userInfo.FullName != 'Khách hàng lẻ' ? this.userInfo.FullName : dataRegister.fullname,
                    phonenumber: this.userInfo.PhoneSMS

                });
            }
        },
        clearUserInfo() {
            this.userInfo.FullName = 'Khách hàng lẻ';
            this.userInfo.TaxCode = '';
            this.address.streetid = 0;
            this.address.streetname = '';
            this.address.housenumber = '';
        },
        mappingPrepayTotal(
            locationId = this.address.locationid,
            districtId = this.address.districtid,
            wardId = this.address.wardid
        ) {
            let packageData = this.sectionSelectedPackage;
            api.getPrePaidPoliciesDetail(
                this.getPrePaidPoliciesDetailCallback,
                parseInt(locationId),
                parseInt(districtId),
                parseInt(wardId),
                parseInt(packageData.ComboType),
                packageData.CategoryService
            );
        },
        getPackageDetails() {
            this.$store.dispatch('system/updateLoading', true);
            let packageData = this.sectionSelectedPackage;
            const location = this.receiptInfoCheck ? this.address : this.location;
            api.getCategoryDetail(
                this.getPackageDetailsCallback,
                parseInt(location.locationid),
                parseInt(location.districtid),
                parseInt(location.wardid),
                0,
                parseInt(packageData.ComboType),
                packageData.CategoryService,
                this.orderId
            );
        },
        getPackageDetailsCallback(isSuccess, data, error) {
            if (isSuccess) {
                if (data.error == 0) {
                    const packages = data.data.ServiceMain.Packages.filter((item) => item.SubServiceTypeId == 18)[0];
                    const dataService = packages.SalesPolicyPackages.find((pack) => pack.PrePaid == this.prepayMonth);
                    if (dataService) {
                        const Packages = [
                            {
                                ServiceId: packages.ServiceId,
                                SubServiceId: packages.SubServiceId,
                                SubServiceTypeId: packages.SubServiceTypeId,
                                SubServiceName: packages.SubServiceName,
                                ServiceSalesPolicy: [
                                    {
                                        PolicyId: dataService.PolicyId,
                                        PolicyType: dataService.PolicyType,
                                        ComboType: dataService.ComboType,
                                        PsId: dataService.PsId,
                                        ProgramId: dataService.ProgramID,
                                        GroupId: dataService.GroupId,
                                        PromotionId: dataService.PromotionId,
                                        PrePaid: dataService.PrePaid,
                                        RealQty: this.sectionSelectedPackage.Qty,
                                    },
                                ],
                            },
                        ];
                        const dataUpdate = {
                            OrderId: this.orderId,
                            RouteName: this.sectionSelectedPackage.CmsContent.route_name || this.$route.params.servicecode,
                            OrderDetail: {
                                Products: [],
                                Packages: Packages,
                                Vouchers: [],
                                RefInfo: {},
                            },
                        };
                        this.updateOrderDetail(dataUpdate);
                    } else {
                        this.hasError(
                            'Gói trả trước hiện tại chưa có chính sách mở bán. Xin quý khách vui lòng chọn lại. Xin cảm ơn'
                        );
                        //cập nhật lại số lượng tối đa
                        if (packages.hasOwnProperty('SalesPolicyPackages')) {
                            const listPrePaid = packages.SalesPolicyPackages;
                            this.getListPrePayMonth(listPrePaid);
                        } else {
                            this.showErrorModal(this.notPackageAvailable);
                        }
                    }
                } else {
                    this.hasError(this.notPackageAvailable);
                }
            } else {
                this.hasError(error);
            }
        },
        getPrePaidPoliciesDetailCallback(isSuccess, data, error) {
            if (isSuccess) {
                if (data.error == 0) {
                    const policies = data.data.ServiceMain.Packages.filter((item) => item.SubServiceTypeId == 18)[0]; 
                    //cập nhật lại số lượng tối đa
                    if (policies.hasOwnProperty('SalesPolicyPackages')) {
                        const listPrePaid = policies.SalesPolicyPackages;
                        this.getListPrePayMonth(listPrePaid);
                        if (this.loadCachedPackages) {
                            this.loadingPrice = false;
                        }
                    } else {
                        this.showErrorModal(this.notPackageAvailable);
                    }
                } else {
                    this.showErrorModal(this.notPackageAvailable);
                }
            } else {
                this.showErrorModal(this.notPackageAvailable);
            }
        },
        getListPrePayMonth(listPrePaid) {
            this.sectionSelectedPackage.RealMonth = listPrePaid[0].RealMonth;
            this.sectionSelectedPackage.RealPromotionMonth = listPrePaid[0].RealPromotionMonth;
            this.sectionSelectedPackage.Qty = this.sectionSelectedPackage.Qty || listPrePaid[0].FromQty
            this.sectionPrepayMonthData = listPrePaid
                .map((item) => {
                    return {
                        key: item.PrePaid,
                        title: `Gói ${item.PrePaid} Tháng`,
                        RealPromotionMonth: item.PrePaidPriceVAT,
                        maxQty: item.ToQty,
                    };
                })
                .sort(function (a, b) {
                    return b.PrePaid - a.PrePaid;
                });
            this.prepayMonth = this.$store.getters['fptplay/prepayMonth'] || this.sectionPrepayMonthData[0].key;
            this.maxPackage = this.getMaxQtyBaseMonth(this.prepayMonth);
        },
        loadCachedData() {
            const dataRegister = this.getFromSessions('dataRegister');
            if (dataRegister) {
                this.userInfo = {
                    FullName: dataRegister.fullname,
                    PhoneSMS: dataRegister.phonenumber,

                };
            } else {
                this.userInfo = this.$store.getters['fptplay/userInfo'] || {
                    FullName: 'Khách hàng lẻ',
                    PhoneSMS: '',
                };
            }
            this.prepayMonth = this.$store.getters['fptplay/prepayMonth'] || 12;
            this.receiptInfoCheck = this.getFromSessions('receiptInfoCheck') || 0;
            this.chosenActive = this.getFromSessions('chosenActive') || 2;
            if (this.getFromCache('dataLocation')) {
                this.address = this.getFromCache('dataLocation');
            }
            if (!this.$store.getters['fptplay/selectedPackage']) {
                this.loadCachedPackages = false;
            } else {
                this.sectionSelectedPackage = this.$store.getters['fptplay/selectedPackage'];
                this.mappingPrepayTotal();
            }
        },
        getPackageFromUrl() {
            let serviceCode = this.$route.params.servicecode;
            if (serviceCode) {
                api.getServiceFromName(this.getPackageFromUrlCallback, serviceCode);
            } else {
                if (!this.loadCachedPackages) {
                    this.showErrorModal('Quý khách vui lòng chọn lại sản phẩm/ dịch vụ');
                }
            }
        },
        getPackageFromUrlCallback(isSuccess, data, error) {
            if (isSuccess) {
                if (data.error == 0) {
                    this.$store.dispatch('system/updateLoading', false);
                    this.sectionSelectedPackage = data.data;
                    //
                    if(this.sectionSelectedPackage?.SysName === 'FPTPlay-SA-XMAS'){
                        this.chosenActive = 2;
                    };
                    //
                    this.$store.dispatch('fptplay/updateSelectedPackage', this.sectionSelectedPackage);
                    this.loadingPrice = false;
                    this.mappingPrepayTotal();
                } else {
                    this.showErrorModal('Quý khách vui lòng chọn lại sản phẩm/ dịch vụ');
                }
            } else {
                this.showErrorModal('Quý khách vui lòng chọn lại sản phẩm/ dịch vụ');
            }
        },
        createOrder() {
            const location = this.receiptInfoCheck ? this.address : this.location;
            const CustomerInfo = {
                IDCardType: 4, // 4 là mã số thuế
                IDCard: this.userInfo.TaxCode,
                FullName: this.receiptInfoCheck ? this.userInfo.FullName : 'Khách hàng lẻ',
                PhoneSMS: this.userInfo.PhoneSMS,
                Gender: 1,
                LocationId: parseInt(location.locationid),
                LocaltionName: location.locationname,
                DistrictId: parseInt(location.districtid),
                DistrictName: location.districtname,
                WardId: parseInt(location.wardid),
                WardName: location.wardname,
                StreetId: parseInt(location.streetid) || 0,
                StreetName: location.streetname || '',
                TypeHouse: 1,
                AddressNo: location.housenumber || '',
                TypeHouse: 1,
                BillingAddress: this.formatAddress,
            };

            const OrderInfo = {
                OrderCode: sessionStorage.getItem('ordercode'),
                Id: parseInt(this.getFromSessions('orderid') || 0),
                OrderType: 1,
                Position: ';',
                TrackingID: this.getTrackingID(),
                SaleTeamId: this.getSaleTeamId(),
                PublicToken: this.getCookie('PublicToken') || '',
                CampInfo: {
                    CampSource: sessionStorage.utm_source || '',
                    CampMedium: sessionStorage.utm_medium || '',
                    CampName: sessionStorage.utm_campaign || '',
                    CampTerm: sessionStorage.utm_term || '',
                    CampContent: sessionStorage.utm_content || '',
                    CampExtra: sessionStorage.extra_tracking ? sessionStorage.extra_tracking : ''
                },
                ReCare: '',
                ReferralCode: '',
            };
            const OrderData = {
                CustomerInfo: CustomerInfo,
                OrderInfo: OrderInfo,
                Vouchers: [],
                OrderFPTPlaySAExtra: {
                    ActivationCodeMethod: this.chosenActive,
                },
            };
            this.handleSaveData();
            api.createFptPlaySAOrder(this.createOrderCallback, OrderData);
        },
        createOrderCallback(isSuccess, data, error) {
            if (isSuccess) {
                if (data.error == 0) {
                    this.$store.dispatch('system/updateLoading', false);
                    this.orderId = data.data.OrderId;
                    this.orderCode = data.data.OrderCode;
                    this.addToSessions('orderid', this.orderId);
                    this.addToSessions('orderidFinish', this.orderId);
                    sessionStorage.setItem('ordercode', this.orderCode);
                    this.sessionSet('ordercode20', this.orderCode, 20);
                    this.getPackageDetails();
                } else {
                    if (data.data?.data_error) {
                        if (data.data.data_error.Code == -2) {
                            this.isCheckBtn = true;
                            this.nametitle = 'Số điện thoại đã được sử dụng';
                            this.namebtn = 'Thay đổi số điện thoại khác';
                            this.orderId = data.data.data_error.OrderId || '';
                            sessionStorage.setItem('order_id_customer', this.orderId);
                        } else {
                            this.isCheckBtn = false;
                            this.namebtn = 'Đồng ý';
                            this.nametitle = 'Thông báo';
                        }
                    } else {
                        this.isCheckBtn = false;
                        this.showErrorForUpdateSurvey(data.message);
                        return;
                    }
                    this.showErrorForUpdateSurvey(data.message);
                }
            } else {
                this.hasError();
            }
        },
        updateOrderDetail(data) {
            api.updateOrderDetail(this.updateOrderDetailCallback, data);
        },
        updateOrderDetailCallback(isSuccess, data, error) {
            if (isSuccess) {
                if (data.error == 0) {
                    this.getMethodPayments();
                    this.$store.dispatch('fptplay/updateSelectedPackage', this.sectionSelectedPackage);
                } else {
                    this.hasError(data.message);
                }
            } else {
                this.hasError(error);
            }
        },
        getMethodPayments() {
            api.getPaymentMethod(this.getPaymentsMethodCallBack, this.orderId);
        },
        getPaymentsMethodCallBack(isSuccess, data, error) {
            if (isSuccess) {
                if (data.error == 0) {
                    this.addToSessions('PaidPaymentType', data.data.PaidPaymentType);
                    this.addToSessions('PaidPaymentTypeDisplay', data.data.PaidPaymentTypeDisplay);
                    this.addToSessions('ISSA', true);
                    window.scrollTo(0, 0);
                    this.$router.push({ name: ROUTER_NAME.payment }).catch(() => { });
                } else {
                    this.hasError();
                }
            } else {
                this.hasError();
            }
        },
        hasError(message) {
            this.$store.dispatch('system/updateLoading', false);
            scrollToError();
            this.$store.dispatch('system/showDialog', {
                description: message ? message : 'Đã có lỗi xảy ra. Vui lòng thử lại',
            });
        },
        showErrorForUpdateSurvey(msg) {
            this.$store.dispatch('system/updateLoading', false);
            const errMsg = msg ? msg : this.defaultErrorMessage;
            this.showNotificationModal(errMsg);
        },
        showNotificationModal(
            message,
            title = this.nametitle ? this.nametitle : 'Thông báo',
            iconId = '#icon-voucher',
            okBtnText = this.namebtn ? this.namebtn : 'Đồng ý'
        ) {
            this.notificationModalInfo = {
                title,
                iconId,
                message,
                okBtnText,
            };
            this.$refs['notification-modal'].showModal();
        },
        pushKHTN() {
            getPotentialCustomer(this.callbackPotentialCustomer, parseInt(this.orderId));
        },
        callbackPotentialCustomer(isSuccess, data, error) {
            if (isSuccess) {
                this.$router
                    .push({
                        name: ROUTER_NAME.finishPotentialCustomers,
                    })
                    .catch(() => { });
            }
        },
        checkForm(e) {
            e.preventDefault();
            this.$store.dispatch('system/updateLoading', true);
            let passed = true;
            Object.keys(this.userInfo).map((item) => {
                const ref = this.$refs[item];
                if (ref) {
                    passed = (!ref || ref.validate()) && passed;
                }
            });
            if (this.receiptInfoCheck) {
                passed = (!this.$refs['address'] || this.$refs['address'].validate()) && passed;
            }
            if (!passed) {
                this.$store.dispatch('system/updateLoading', false);
                scrollToError();
                return;
            }
            this.createOrder();
        },
        getMaxQtyBaseMonth(value) {
            let prepaid = this.sectionPrepayMonthData.find((item) => item.key == value);

            if (!prepaid) {
                return 0;
            }

            return prepaid.maxQty;
        },
    },

    created() {
        this.loadCachedData();
        sessionStorage.step = 1;
        this.$store.dispatch('fptplay/updateStep', 1);
    },
    mounted() {
        let routerServiceCode = this.$route.params.servicecode;
        if (!this.loadCachedPackages) {
            this.getPackageFromUrl();
        } else {
            let cacheServiceCode = this.sectionSelectedPackage.serviceCode;
            if (routerServiceCode != cacheServiceCode) {
                this.getPackageFromUrl();
            }
        }
        this.getDefaultLocation();
    },
    watch: {
        prepayMonth(value) {
            this.$store.dispatch('fptplay/updatePrepayMonth', value);
            this.maxPackage = this.getMaxQtyBaseMonth(value);
        },
        'receiptChecking.id': function (value) {
            this.receiptInfoCheck = parseInt(value);
        },
        receiptInfoCheck: function (value) {
            if (parseInt(value) === 0) {
                this.clearUserInfo();
            }

            if (parseInt(value) == 1 && this.userInfo.FullName == 'Khách hàng lẻ') {
                this.userInfo.FullName = '';
            }
        },
    },
    computed: {
        formatAddress() {
            if (this.receiptInfoCheck) {
                if (this.address.streetid != 0) {
                    return `${this.address.housenumber} ${this.address.streetname}, ${this.address.wardname}, ${this.address.districtname}, ${this.address.locationname}`;
                }
                return `${this.address.wardname}, ${this.address.districtname}, ${this.address.locationname}`;
            }

            return `${this.location.wardname}, ${this.location.districtname}, ${this.location.locationname}`;
        },
    },
};
</script>
